import { render } from "./PersonnelDetails.vue?vue&type=template&id=81a32084&scoped=true&ts=true"
import script from "./PersonnelDetails.vue?vue&type=script&lang=ts"
export * from "./PersonnelDetails.vue?vue&type=script&lang=ts"

import "./PersonnelDetails.vue?vue&type=style&index=0&id=81a32084&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81a32084"]])

export default __exports__